<div class="page_auth">
  <div class="auth_top">
    <img src="/icons/logo.png" alt="Secur Logo" />
    <h2>Securpro</h2>
    <h3>SISTEMA DE GESTÃO DE SEGURANÇA</h3>
  </div>

  <form [formGroup]="formLogin" class="form_auth" (ngSubmit)="submit()" novalidate>
    <div class="input_camp" [class.input_camp--invalid]="isInvalid('username')">
      <label for="username">Utilizador</label>
      <div class="insert_camp">
        <i class="pi pi-user field-icon" aria-hidden="true"></i>

        <input
          id="username"
          type="text"
          placeholder="NIF ou e-mail"
          formControlName="username"
          autocomplete="username"
          aria-describedby="username-error"
          [attr.aria-invalid]="isInvalid('username')"
          autofocus
          pInputText
          class="auth-input"
        />
      </div>

      <small id="username-error" class="error" role="alert" *ngIf="isInvalid('username')">
        O utilizador é obrigatório.
      </small>
    </div>

    <div class="input_camp" [class.input_camp--invalid]="isInvalid('password')">
      <label for="password">Palavra-passe</label>

      <div class="insert_camp">
        <i class="pi pi-lock field-icon" aria-hidden="true"></i>

        <input
          id="password"
          type="password"
          class="auth-input"
          placeholder="Digite a sua palavra-passe"
          formControlName="password"
          [type]="showPassword ? 'text' : 'password'"
          autocomplete="current-password"
          aria-describedby="password-error"
          [attr.aria-invalid]="isInvalid('password')"
          pInputText
        />

        <button
          type="button"
          class="password-toggle"
          (click)="toggleVisiblePassword()"
          [attr.aria-label]="showPassword ? 'Ocultar palavra-passe' : 'Mostrar palavra-passe'"
          [attr.aria-pressed]="showPassword"
        >
          <i
            [class]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"
            aria-hidden="true"
          ></i>
        </button>
      </div>

      <small id="password-error" class="error" role="alert" *ngIf="isInvalid('password')">
        A palavra-passe é obrigatória.
      </small>
    </div>

    <div class="auth_actions">
      <div>
        <p-checkbox
          inputId="remember"
          class="remember"
          formControlName="remember"
          [binary]="true"
          size="small"
        />

        <label for="remember">Lembrar-me</label>
      </div>

      <button
        type="button"
        disabled
        pTooltip="Endpoint de recuperação de password ainda não disponível no backend."
        tooltipPosition="top"
      >
        Esqueci a senha
      </button>
    </div>

    <button type="submit" class="btn-entrar" [disabled]="loading">
      <span *ngIf="!loading">
        <i class="ri-shield-check-line"></i>
        Entrar
      </span>

      <span *ngIf="loading">
        <i class="ri-loader-4-line spin"></i>
        A autenticar...
      </span>
    </button>

    <a routerLink="/primeiro-login" class="link-primeiro-acesso">
      Primeiro acesso? Definir palavra-passe
    </a>

    <div class="atencion">
      <span></span>
      <p>APENAS PESSOAL AUTORIZADO</p>
      <span></span>
    </div>
  </form>
</div>